import { agentApi } from './agentApi';

export function computeConversationCount(details: any): number {
  if (Array.isArray(details)) return details.length;
  if (!details || typeof details !== 'object') return 0;
  const candidates: any[][] = [
    details.users,
    details.agentUsers,
    details.conversations,
    details.data
  ].filter(Array.isArray);
  if (candidates.length > 0) return candidates[0]!.length;
  if (typeof details.ChatHistoryCount === 'number') return details.ChatHistoryCount;
  if (details.userId || details.userid || details.id) return 1;
  return 0;
}

export async function fetchConversationCount(agentId: string): Promise<number> {
  try {
    const details = await agentApi.getAgentDetails(agentId);
    return computeConversationCount(details);
  } catch {
    return 0;
  }
}

export async function fetchConversationCounts(agentIds: string[]): Promise<Record<string, number>> {
  const entries = await Promise.all(
    agentIds.map(async (id) => [id, await fetchConversationCount(id)] as const)
  );
  const map: Record<string, number> = {};
  for (const [id, count] of entries) map[id] = count;
  return map;
}


